import { Component, Input, OnInit } from '@angular/core';
import { Option } from '../../types/form.type';
// import { ConfigService, CountryCodeList } from '@hospitality-bot/admin/shared';
import { FormComponent } from '../../components/form-component/form.components';
import { ControlContainer, Validators } from '@angular/forms';
import { ConfigService } from '../../services/config.service';
import { CountryCodeList } from '../../models/country-code.model';

@Component({
  selector: 'hospitality-bot-phone-number',
  templateUrl: './phone-number.component.html',
  styleUrls: [
    './phone-number.component.scss',
    '../../components/form-component/select/select.component.scss',
  ],
})
export class PhoneNumberComponent extends FormComponent {
  @Input() preControlNameVisible = true;
  @Input() postControlNameVisible = true;
  @Input() preControlName: string = 'cc';
  @Input() postControlName: string = 'phoneNumber';
  @Input() label: string = 'Phone Number';
  code: Option[] = [];

  constructor(
    private configService: ConfigService,
    public controlContainer: ControlContainer
  ) {
    super(controlContainer);
  }

  ngOnInit(): void {
    this.initInputControl(this.preControlName);
    this.getCountryCode();
    this.listenForValueChanges();

    const phoneControl = this.controlContainer.control?.get(
      this.postControlName
    );
    if (phoneControl) {
      const existingValidators = phoneControl.validator
        ? [phoneControl.validator]
        : [];
      phoneControl.setValidators([
        ...existingValidators,
        Validators.minLength(4),
        Validators.maxLength(17),
        Validators.pattern('^[0-9]*$'),
      ]);
      phoneControl.updateValueAndValidity();
    }
  }

  listenForValueChanges() {
    this.controlContainer.control
      ?.get(this.preControlName)
      ?.valueChanges.subscribe((response) => {
        if (!response) {
          this.controlContainer.control
            ?.get(this.preControlName)
            ?.patchValue('+91');
        } else if (!response.startsWith('+')) {
          this.controlContainer.control
            ?.get(this.preControlName)
            ?.patchValue(`+${response}`);
        }
      });
  }

  getCountryCode() {
    this.loading = true;
    this.configService.getCountryCode().subscribe(
      (res) => {
        let data = new CountryCodeList().deserialize(res);
        data.records.forEach((element) => {
          element.label = element.label + ' (' + element.value + ')';
          element.value = element.value;
        });

        this.code = data.records;
      },
      () => {},
      this.handleFinal
    );
  }

  handleFinal = () => {
    this.loading = false;
  };
}
